import { GetServerSideProps } from 'next';

export const getQueryParam = (name: string): string | null => {
  if (typeof window === 'undefined' || !document) {
    return null;
  }

  return new URL(document.location.href).searchParams.get(name);
};

/*
  Use in case NextJS is not able to serialize in JSON your data (class objects, undefined values...)
  https://github.com/vercel/next.js/issues/11993
*/
export const ensureJSONSerializable = (data: unknown) => {
  return JSON.parse(JSON.stringify(data));
};

export const injectGetServerSidePropsHeaders = <
  T extends { [key: string]: any },
>(
  pagePropsFetcher: GetServerSideProps<T>,
) => {
  return async (context: any) => {
    const result = await pagePropsFetcher(context);

    if ('redirect' in result) {
      context.res.setHeader(
        'Cache-Control',
        'no-store, no-cache, must-revalidate',
      );
    } else {
      context.res.setHeader(
        'Cache-Control',
        'max-age=0, s-maxage=1800, public, stale-while-revalidate=300, stale-if-error=86400',
      );
    }

    return result;
  };
};
